import { z } from 'zod'

const envSchema = z.object({
  VITE_APP_API_URL: z
    .string({
      message: 'No se encuentra la variable de entorno VITE_APP_API_URL'
    })
    .nonempty('La variable de entorno VITE_APP_API_URL no tiene valor'),
  VITE_APP_WALLET_API_URL: z
    .string({
      message: 'No se encuentra la variable de entorno VITE_APP_WALLET_API_URL'
    })
    .nonempty('La variable de entorno VITE_APP_WALLET_API_URL no tiene valor'),
  VITE_APP_MANAGEMENT_API_URL: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_MANAGEMENT_API_URL'
    })
    .nonempty(
      'La variable de entorno VITE_APP_MANAGEMENT_API_URL no tiene valor'
    ),
  VITE_APP_WALLET_API_VERSION: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_WALLET_API_VERSION'
    })
    .nonempty(
      'La variable de entorno VITE_APP_WALLET_API_VERSION no tiene valor'
    ),
  VITE_APP_API_VERSION: z
    .string({
      message: 'No se encuentra la variable de entorno VITE_APP_API_VERSION'
    })
    .nonempty('La variable de entorno VITE_APP_API_VERSION no tiene valor'),
  VITE_APP_APPLE_BRAND_ID: z
    .string({
      message: 'No se encuentra la variable de entorno VITE_APP_APPLE_BRAND_ID'
    })
    .nonempty('La variable de entorno VITE_APP_APPLE_BRAND_ID no tiene valor'),
  VITE_APP_MAX_CLIENT_WALLET_RECHARGE: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_MAX_CLIENT_WALLET_RECHARGE'
    })
    .nonempty(
      'La variable de entorno VITE_APP_MAX_CLIENT_WALLET_RECHARGE no tiene valor'
    ),
  VITE_APP_WEPPA_COMMERCIAL_ALLY_ID: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_WEPPA_COMMERCIAL_ALLY_ID'
    })
    .nonempty(
      'La variable de entorno VITE_APP_WEPPA_COMMERCIAL_ALLY_ID no tiene valor'
    ),
  VITE_APP_WEPPA1_REPORTS_URL: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_WEPPA1_REPORTS_URL'
    })
    .nonempty(
      'La variable de entorno VITE_APP_WEPPA1_REPORTS_URL no tiene valor'
    ),
  VITE_APP_PUBLIC_MUI_X_LICENSE_KEY: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_PUBLIC_MUI_X_LICENSE_KEY'
    })
    .nonempty(
      'La variable de entorno VITE_APP_PUBLIC_MUI_X_LICENSE_KEY no tiene valor'
    ),
  VITE_APP_EXCEPTIONLESS_KEY: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_EXCEPTIONLESS_KEY'
    })
    .nonempty(
      'La variable de entorno VITE_APP_EXCEPTIONLESS_KEY no tiene valor'
    ),
  VITE_APP_EXCEPTIONLESS_URL: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_EXCEPTIONLESS_URL'
    })
    .nonempty(
      'La variable de entorno VITE_APP_EXCEPTIONLESS_URL no tiene valor'
    ),
  VITE_APP_SHOW_RENTABILITY_POLICY: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_SHOW_RENTABILITY_POLICY'
    })
    .nonempty(
      'La variable de entorno VITE_APP_SHOW_RENTABILITY_POLICY no tiene valor'
    ),
  VITE_APP_ENHANCE_CODE_SECURITY: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_ENHANCE_CODE_SECURITY'
    })
    .nonempty(
      'La variable de entorno VITE_APP_ENHANCE_CODE_SECURITY no tiene valor'
    ),
  VITE_APP_GOOGLE_MAPS_API_KEY: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_GOOGLE_MAPS_API_KEY'
    })
    .nonempty(
      'La variable de entorno VITE_APP_GOOGLE_MAPS_API_KEY no tiene valor'
    ),
  VITE_APP_VEHICLE_CLASSES: z
    .string({
      message: 'No se encuentra la variable de entorno VITE_APP_VEHICLE_CLASSES'
    })
    .nonempty('La variable de entorno VITE_APP_VEHICLE_CLASSES no tiene valor'),
  VITE_APP_MARKETPLACE_API_URL: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_MARKETPLACE_API_URL'
    })
    .nonempty(
      'La variable de entorno VITE_APP_MARKETPLACE_API_URL no tiene valor'
    ),
  VITE_APP_VEHICLE_COLORS: z
    .string({
      message: 'No se encuentra la variable de entorno VITE_APP_VEHICLE_COLORS'
    })
    .nonempty('La variable de entorno VITE_APP_VEHICLE_COLORS no tiene valor'),
  VITE_APP_ACCOUNT_TYPES: z
    .string({
      message: 'No se encuentra la variable de entorno VITE_APP_ACCOUNT_TYPES'
    })
    .nonempty('La variable de entorno VITE_APP_ACCOUNT_TYPES no tiene valor'),
  VITE_APP_MARITAL_STATUS: z
    .string({
      message: 'No se encuentra la variable de entorno VITE_APP_MARITAL_STATUS'
    })
    .nonempty('La variable de entorno VITE_APP_MARITAL_STATUS no tiene valor'),
  VITE_APP_SHOW_MARKETPLACE: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_SHOW_MARKETPLACE'
    })
    .nonempty(
      'La variable de entorno VITE_APP_SHOW_MARKETPLACE no tiene valor'
    ),
  VITE_APP_SHOW_DRAW: z
    .string({
      message: 'No se encuentra la variable de entorno VITE_APP_SHOW_DRAW'
    })
    .nonempty('La variable de entorno VITE_APP_SHOW_DRAW no tiene valor'),
  VITE_APP_JUMIO_MANUAL_VERIFY_DELAY_SECONDS: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_JUMIO_MANUAL_VERIFY_DELAY_SECONDS'
    })
    .nonempty(
      'La variable de entorno VITE_APP_JUMIO_MANUAL_VERIFY_DELAY_SECONDS no tiene valor'
    )
    .refine((val) => Number.isFinite(Number(val)) && Number(val) >= 0, {
      message:
        'La variable de entorno VITE_APP_JUMIO_MANUAL_VERIFY_DELAY_SECONDS debe ser un número mayor o igual a 0'
    }),
  VITE_APP_FIREBASE_API_KEY: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_FIREBASE_API_KEY'
    })
    .nonempty(
      'La variable de entorno VITE_APP_FIREBASE_API_KEY no tiene valor'
    ),
  VITE_APP_FIREBASE_AUTH_DOMAIN: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_FIREBASE_AUTH_DOMAIN'
    })
    .nonempty(
      'La variable de entorno VITE_APP_FIREBASE_AUTH_DOMAIN no tiene valor'
    ),
  VITE_APP_FIREBASE_PROJECT_ID: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_FIREBASE_PROJECT_ID'
    })
    .nonempty(
      'La variable de entorno VITE_APP_FIREBASE_PROJECT_ID no tiene valor'
    ),
  VITE_APP_FIREBASE_STORAGE_BUCKET: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_FIREBASE_STORAGE_BUCKET'
    })
    .nonempty(
      'La variable de entorno VITE_APP_FIREBASE_STORAGE_BUCKET no tiene valor'
    ),
  VITE_APP_FIREBASE_MESSAGING_SENDER_ID: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_FIREBASE_MESSAGING_SENDER_ID'
    })
    .nonempty(
      'La variable de entorno VITE_APP_FIREBASE_MESSAGING_SENDER_ID no tiene valor'
    ),
  VITE_APP_FIREBASE_APP_ID: z
    .string({
      message: 'No se encuentra la variable de entorno VITE_APP_FIREBASE_APP_ID'
    })
    .nonempty('La variable de entorno VITE_APP_FIREBASE_APP_ID no tiene valor'),
  VITE_APP_FIREBASE_MEASUREMENT_ID: z
    .string({
      message:
        'No se encuentra la variable de entorno VITE_APP_FIREBASE_MEASUREMENT_ID'
    })
    .nonempty(
      'La variable de entorno VITE_APP_FIREBASE_MEASUREMENT_ID no tiene valor'
    ),
  PROD: z.boolean({
    message: 'No se encuentra la variable de entorno PROD'
  })
})

export const env = envSchema.parse(import.meta.env)
